import React from 'react';

import Utils from 'files/Utils.js';

const FIRE = '#D63D1F';
const PRIMARY_GREEN = '#1B5E20';
const SECONDARY_DARK = '#242F3F';

const FEATURES = [{
    icon: 'fas fa-dollar-sign',
    title: 'No Monthly Fees',
    description: 'Fully featured devices with zero monthly monitoring fees. One-time purchase, lifetime protection.'
},{
    icon: 'fas fa-bell',
    title: '24/7 Notifications',
    description: 'Rapid response through our interconnected wireless network, alerting you to danger around the clock.'
},{
    icon: 'fas fa-envelope',
    title: 'SMS & Email Alerts',
    description: 'Instant text and email notifications sent to up to 8 emergency contacts when danger is detected.'
},{
    icon: 'fas fa-shield-alt',
    title: 'Lifetime Replacement',
    description: 'Complete peace of mind with our lifetime replacement program. We stand behind our products.'
}];

const Features = () => {

    const isMobile = Utils.isMobile();

    return (
        <section
        id={'features'}
        style={{
            backgroundColor: '#F5F6FA',
            padding: '48px 0',
            width: '100%'
        }}>
            <div style={{
                margin: '0 auto',
                maxWidth: 1280,
                padding: '0 16px',
                width: '100%'
            }}>
                <div style={{
                    marginBottom: 64,
                    textAlign: 'center'
                }}>
                    <p style={{
                        color: PRIMARY_GREEN,
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: isMobile ? 20 : 24,
                        fontWeight: 700,
                        letterSpacing: 2,
                        margin: '0 0 16px 0',
                        textTransform: 'uppercase'
                    }}>{'Why Choose OmniShield?'}</p>
                    <h2 style={{
                        color: SECONDARY_DARK,
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: isMobile ? 36 : 48,
                        fontWeight: 700,
                        margin: '0 0 16px 0'
                    }}>{'Protection You Can Trust'}</h2>
                    <p style={{
                        color: '#6F6F6F',
                        fontFamily: '"Lato", sans-serif',
                        fontSize: 16,
                        lineHeight: 1.6,
                        margin: '0 auto',
                        maxWidth: 672
                    }}>{'Every 24 seconds, a home fire is reported in the U.S. Don\'t wait until it\'s too late — our interconnected sensors detect danger faster and alert you instantly, giving your family the precious seconds they need to escape safely.'}</p>
                </div>
                <div style={{
                    display: 'grid',
                    gap: 24,
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)'
                }}>
                    {FEATURES.map((feature, index) => (
                        <div
                        key={index}
                        style={{
                            alignItems: 'center',
                            backgroundColor: '#FFFFFF',
                            border: `1px solid rgba(27,94,32,0.2)`,
                            borderRadius: 16,
                            boxShadow: '0 4px 24px -4px rgba(36,47,63,0.1)',
                            display: 'flex',
                            flexDirection: 'column',
                            padding: 32,
                            textAlign: 'center'
                        }}>
                            <div style={{
                                alignItems: 'center',
                                background: `linear-gradient(135deg, rgba(214,61,31,0.2), rgba(255,107,61,0.1))`,
                                borderRadius: '50%',
                                display: 'flex',
                                height: 64,
                                justifyContent: 'center',
                                marginBottom: 24,
                                width: 64
                            }}>
                                <i
                                className={feature.icon}
                                style={{
                                    color: FIRE,
                                    fontSize: 28
                                }} />
                            </div>
                            <h3 style={{
                                color: SECONDARY_DARK,
                                fontFamily: '"Poppins", sans-serif',
                                fontSize: 20,
                                fontWeight: 600,
                                margin: '0 0 8px 0'
                            }}>{feature.title}</h3>
                            <p style={{
                                color: '#6F6F6F',
                                fontFamily: '"Lato", sans-serif',
                                fontSize: 14,
                                lineHeight: 1.6,
                                margin: 0
                            }}>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Features;
